import React, {useEffect, useRef} from 'react'
import { useDispatch, useSelector } from "react-redux";
import {useNavigate } from "react-router-dom";
import { Sidebar } from "primereact/sidebar";
import moment from "moment"

import "./index.css"

import { InputSwitchField } from '../../../helpers';
import Menu from '../../../helpers/Menu';
import Table from '../../../helpers/Table';

import ButtonGroup from '../../../common/ButtonGroup';

import CompanySearchBar from '../CompanySearchBar';

import { raiseToast } from '../../../services/redux/reducers/toast/toast';
import { fetchCompanyTypes } from '../../../services/redux/reducers/commonThunk';
import { fetchCompanyList, updateCompanyListData, setIsSearchVisible } from '../../../services/redux/reducers/companyList/comapnyList';
import { updateCompanyStatus } from '../../../services/api/company';

import { isMobile } from '../../../utils';
import { DATE_FORMAT } from '../../../constants';


const CompanyList = () => {

    const navigate = useNavigate()
    const actionMenu = useRef(null)
    const dispatch = useDispatch()

    const companyData = useSelector(state => state.companies.companyListData)
    const isLoading = useSelector(state => state.companies.loading)
    const paginationParams = useSelector(state => state.companies.paginationParams)
    const searchParams = useSelector(state => state.companies.searchParams)
    const isSearchVisible = useSelector(state => state.companies.isSearchVisible)
    const isSearchActive = useSelector(state => state.companies.isSearchActive)

    const companyTypes = useSelector(state => state.common.companyTypes)

    const isMobileDevice = isMobile()

    useEffect(() => {
        dispatch(fetchCompanyTypes())
    }, [])

    const handlePageChange = async (e) => {
        let getCompanyParams = { 
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }

        if (getCompanyParams.searchBy !== "all") {
            getCompanyParams[getCompanyParams.searchBy] = getCompanyParams.searchText.trim()
        }
        dispatch(fetchCompanyList(getCompanyParams))
    }

    const handleUpdateCompanyStatus = async (row) => {
        if(row.statusId === 1){
            if(window.confirm("Do u want to deactivate this company")){
                const updatedResponse = await updateCompanyStatus({statusId: 2}, row.companyId)
                if(updatedResponse.failure){
                    return dispatch(raiseToast({severity:'error', summary: 'Company', detail: "Company can't found", life: 3000})) 
                }else{
                    const updatedList = companyData.map((eachCompanyData) => {
                        if(eachCompanyData.companyId === row.companyId){
                            return {
                                ...eachCompanyData,
                                statusId: 2
                            }
                        }else{
                            return {...eachCompanyData}
                        }
                    })

                    dispatch(updateCompanyListData(updatedList))
                    dispatch(raiseToast({severity:'success', summary: 'Company', detail: "Updated company status", life: 3000}))
                }
            }
        }else{
            if(window.confirm("Do u want to activate this company")){
                const updatedResponse = updateCompanyStatus({statusId: 1}, row.companyId)
                if(updatedResponse.failure){
                    return dispatch(raiseToast({severity:'error', summary: 'Company', detail: "Company can't found", life: 3000})) 
                }else{
                    const updatedList = companyData.map((eachCompanyData) => {
                        if(eachCompanyData.companyId === row.companyId){
                            return {
                                ...eachCompanyData,
                                statusId: 1
                            }
                        }else{
                            return {...eachCompanyData}
                        }
                    })

                    dispatch(updateCompanyListData(updatedList))
                    dispatch(raiseToast({severity:'success', summary: 'Company', detail: "Updated company status", life: 3000}))
                }
            }
        }
    }

    const getDateBody = (row) =>{
        return(
            moment(row.createdAt).format(DATE_FORMAT)
        )
    }

    const getStatusBody = (row) =>{
        return(
            <InputSwitchField onChange={() => handleUpdateCompanyStatus(row)} checked={row.statusId === 1 ? true : false} disabled={[5, 7].includes(row.statusId)} permissions={[24]}/> 
        )
    }

    const getBuyerSellerBody = (row) => {
        const relatedCompanyType = companyTypes.find((each) => each.companyTypeId === row.buyerSeller)
        if(relatedCompanyType?.companyType){
            return relatedCompanyType.companyType
        }else{
            return row.buyerSeller
        }
    }

    const navigateToEdit  = (row) => {
        return <p onClick={() => window.open(`/company/${row.companyId}`)} style={{fontSize : "13px", textDecoration: "underline", color: "#3366cc", cursor: "pointer", padding: "0px", margin: "0px"}}>{row.companyName}</p>
    }

    const actionMenuItems = [
        {
            label: 'Add Company',
            icon: '',
            command: () => {
                navigate("/company/add")
            },
            permissions: [25]
        }
    ]

    const tableColumns = [
        {
            header: 'Company Name',
            field: '',
            body: navigateToEdit,
            style: { minWidth: "250px"}
        },
        {
            header: 'Company Description',
            field: 'companyDescription',
            style: { minWidth: "250px"}
        },
        {
            header: 'Short Name',
            field: 'companyShortName',
            style: { minWidth: "150px"}
        },
        {
            header: 'Buyer/Seller',
            field: '',
            body: getBuyerSellerBody
        },
        {
            header: 'CreatedAt',
            field: 'createdAt',
            body: getDateBody
        },
        {
            header: 'Status',
            field: '',
            body: getStatusBody
        } 
    ]

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]
    
    return (
        <div className='flex flex-column'>
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">COMPANIES</h4> 
                <div className="flex gap-2 justify-content-end mb-2">
                    {/* <div className='req-action-Body'>
                        <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                        <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    </div>
                    <Button icon="pi pi-filter" className={`h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                    <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>

            <div className='flex flex-row'>
                <div className="company-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'"}}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table 
                                lazy 
                                page={paginationParams.pageNo} 
                                onPageChange={(e)=> handlePageChange(e)} 
                                totalRecords={paginationParams.totalRecords} 
                                tableColumns={tableColumns} 
                                data={companyData} 
                                rows={paginationParams.recordsPerPage} 
                                scrollable={"true"} 
                                scrollHeight="550px"
                                paginator
                                excessPagesFound= {paginationParams.excessPagesFound}
                                loading={isLoading}  
                            />
                        </div>
                    </div>
                </div>
                {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px"}}  className="justify-content-end ">
                        <CompanySearchBar />
                    </div>
                }

                {
                    isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <CompanySearchBar />
                        </Sidebar>
                    </div>
                }
            </div>
        </div>
    )
}

export default CompanyList;